import z from 'zod';
import { NotificationIdSchema } from './console-notifications.types.js';
export const alertCountsResponseSchema = z.object({
    alertCounts: z.record(NotificationIdSchema, z.number()),
});
